import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

import ContentItemVod from "../../components/ContentItemVod";

class TagSearchBoxSame extends PureComponent {
  state = {
    //list: []
    onOverWith: false,
  };
  _isMounted = false;
  componentDidMount = async () => {
    this._isMounted = true;

    //const { getSearchData, gotoPage } = this.props.childProps;
    //const contentList = await getSearchData(gotoPage)
    ////console.log()
    //this.setState({
    //    contentList
    //})
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _onEndItemSlide = (num, over) => {
    //alert(num)
    ////console.log(num)
    ////console.log(num%6)
    ////console.log(over)
    if (parseInt(num % 6) === 0) {
      //console.log('over...')
      //console.log(over)
      if (this._isMounted) {
        this.setState({
          onOverWith: over,
        });
      }
    }
  };
  _renderItem = () => {
    const { searchList } = this.props.childProps;

    const list = searchList.map((item, index) => {
      return (
        <div style={{ display: "inline-block" }} key={index}>
          <ContentItemVod
            num={index + 1}
            refer={"tagSearch"}
            contentSerial={item.contentSerial}
            title={item.title}
            genreName={item.genreName}
            img={item.img}
            overImg={item.overImg}
            restrictionCode={item.restrictionCode}
            opening={item.opening}
            director={item.director}
            contentSysnopsis={item.contentSysnopsis}
            wishFlag={item.wishFlag}
            contentPartSerial={item.contentPartSerial}
            onEndItemSlide={this._onEndItemSlide}
            subTitle={item.subTitle}
            itemSize={"small"}
            weekTime={item.weekTime}
            weekNo={item.weekNo}
            dRank={item.rank}
          />
        </div>
      );
    });

    return list;
  };
  render() {
    const { onOverWith } = this.state;
    const { searchList } = this.props.childProps;
    return (
      <Fragment>
        <div
          className="one_line"
          style={
            onOverWith
              ? { transition: "all ease 0.7s", marginLeft: 0 }
              : { transition: "all ease 0.7s", paddingLeft: 0 }
          }
        >
          <div
            className="div_ul"
            style={
              onOverWith
                ? { transition: "all ease 0.7s", marginLeft: -180 }
                : { transition: "all ease 0.7s", paddingLeft: 0 }
            }
          >
            {searchList ? this._renderItem() : null}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(TagSearchBoxSame));
